import React from "react";
import { useHistory } from "react-router";
import DownIcon from "@atlaskit/icon/glyph/chevron-down";
import DropdownMenu, { DropdownItem, DropdownItemGroup } from "@atlaskit/dropdown-menu";

import Button from "@atlaskit/button/standard-button";

import { URL } from "../../constants/navigation";

export const MatchedUsersDropdown = () => {
  const { push } = useHistory();

  const handleClick = (url: string) => () => push(url);

  return (
    <DropdownMenu
      trigger={({ triggerRef, ...props }) => (
        <Button {...props} appearance="link" iconAfter={<DownIcon label="Actions" />} ref={triggerRef}>
          Actions
        </Button>
      )}
    >
      <DropdownItemGroup>
        <DropdownItem onClick={handleClick(URL.USERS_MATCH)}>Match Users</DropdownItem>
        <DropdownItem onClick={handleClick(URL.ROOMMATE_MATCHING_REPORT)}>Roommate Report</DropdownItem>
      </DropdownItemGroup>
    </DropdownMenu>
  );
};
